<template>
    <ListReports
        ref="reports"
        :load-on-start="false"
        resource="opportunities"
    />
</template>

<script>
	import API from '../../../api';
	import ListReports from '../../List/ListReports';
	import FormControlSector from '../../Form/Control/FormControlSector';
	import FormControlDatepicker from '../../Form/Control/FormControlDatepicker';
	import ReportTab from './ReportTab';
	import FormControlReportType from '../../Form/Control/FormControlReportType';

	export default {
		name: 'ReportTabOpportunities',
		mixins: [ReportTab],
		components: {
			FormControlReportType,
			FormControlDatepicker,
			FormControlSector,
			ListReports,
		},
		data() {
			return {
				formData: {
					sectors: [],
					fromDate: null,
					toDate: null,
					mandated: false,
				},
			}
		},
		methods: {
			fetchResourceCount() {
				return API.getOpportunities(this.formData).then(response => {
					return response.meta.total;
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
</style>
